module.exports = __webpack_public_path__ + "img/dollar-sign-solid.eea0548a.svg";